import { render, staticRenderFns } from "./FichaPesquisa.vue?vue&type=template&id=d85f0ca6&"
import script from "./FichaPesquisa.vue?vue&type=script&lang=js&"
export * from "./FichaPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports